import { IPublishDestination } from '../../types';

/** The key a publish selection addresses a destination by. */
export const destinationId = ({ destination_id, channel_id }: IPublishDestination): string =>
  destination_id ?? channel_id;
